import BrowserQueryMenu from './BrowserQueryMenu';

export default BrowserQueryMenu;
